/* tslint:disable:typedef-whitespace align no-trailing-whitespace import-spacing */

import {Action, ActionType}    from '@/models/action';
import {Logger}                from '@/util/logger';
import {WindowService}         from "@/services/window.service";
import {WindowType}            from '@/screens/ide/window';

/**
 *
 * @class WindowProjectAction
 *
 * @brief ensure project window is open
 *
 * - - - - - - - - - - - - - - - - - - -
 * @author    Michael Garvin (mike.garvin@ironroad.ca)
 * @date      March 2020
 *
 */
export class WindowProjectAction extends Action {

  private      windows: WindowService = null;

  constructor(options: any = null) {

    super({
      key:   'window.project',
      type:  ActionType.Window_Project,
      label: 'Project',
      icon:  '<i class="fas fa-project-diagram"></i>',
      tip:   'Ensure the project window is open'
    });

    this.windows  = this.injector().get(WindowService);
  }

  /* is this action enabled? */
  public enabled(): boolean {

    return true;
  }

  /** implement the action */
  public execute(): boolean {

    if (!this.enabled()) {
      return false;
    }

    Logger.debug('[WindowProjectAction] executing...');

    this.windows.toggleWindow(WindowType.Project);

    return true;
  }
}
